module.exports = __webpack_public_path__ + "static/media/edit.75093e74.svg";